import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import employeeServices from '../employeeServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import AwsImageInline from '../../../../../components/InlineEdit/AwsImageInline';


function EmployeeForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        employeeName:"",
        employeeType:"",
        employeeCode:"",
        employeeDesignation:"",
        city:"",
        state:"",
        address:"",
        zip:"",
        phone:"",
        alternatePhone:"",
        email:"",
        aadhar:"",
        vehicle:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            employeeName:data.employeeName,
            employeeType:data.employeeType,
            employeeCode:data.employeeCode,
            employeeDesignation:data.employeeDesignation,
            city:data.city,
            state:data.state,
            address:data.address,
            zip:data.zip,
            phone:data.phone,
            alternatePhone:data.alternatePhone,
            email:data.email,
            aadhar:data.aadhar,
            vehicle:data.vehicle,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        employeeName:Yup.string().required("Required"),
        employeeType:Yup.string().required("Required"),
        employeeDesignation:Yup.string().required("Required"),
        phone:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits"),
        aadhar:Yup.string().length(12, "Aadhar number must be exactly 12 digits"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        employeeServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Employee</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Employee"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Employee Name" name="employeeName" 
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Employee Type" name="employeeType"  
                                                        options={masters['employee-type']} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Employee Code" name="employeeCode" 
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Employee Designation" name="employeeDesignation"  
                                                        options={masters['employee-designation']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Phone" name="phone" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Alternate Phone" name="alternatePhone" 
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Email" name="email"   
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Aadhar #" name="aadhar"   
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Vehicle #" name="vehicle"   
                                                    />
                                                </div>

                                                <hr className='my-3' />
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="City" name="city"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="State" name="state"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Pincode" name="zip"   
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Address" name="address"   
                                                    />
                                                </div>

                                            </div>

                                            {data &&
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <h3>Employee Photo</h3>
                                                        <AwsImageInline
                                                            label="Employee Photo"
                                                            name="photo"
                                                            value={data.photo}
                                                            editId={data.id}
                                                            save={employeeServices.save}
                                                            updateInline={null}
                                                            path="employee/photo"
                                                            fileId={"photo"}
                                                            onSuccess={()=>{}}
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <h3>ID Proff 1</h3>
                                                        <AwsImageInline
                                                            label="Employee ID 1"
                                                            name="idProof1"
                                                            value={data.idProof1}
                                                            editId={data.id}
                                                            save={employeeServices.save}
                                                            updateInline={null}
                                                            path="employee/idproof"
                                                            fileId={"idProof1"}
                                                            onSuccess={()=>{}}
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <h3>ID Proff 2</h3>
                                                        <AwsImageInline
                                                            label="Employee ID 2"
                                                            name="idProof2"
                                                            value={data.idProof2}
                                                            editId={data.id}
                                                            save={employeeServices.save}
                                                            updateInline={null}
                                                            path="employee/idproof"
                                                            fileId={"idProof2"}
                                                            onSuccess={()=>{}}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default EmployeeForm